/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function AggregationTabController(
    this: JS5Object,
    $q: JS5Object,
    $timeout: JS5Function,
    uiGridConstants: JS5Object,
    AggregationResourceFactory: JS5Object,
    ContentEditService: JS5Object,
    DownloadAssetService: JS5Object,
    EndPointService: JS5Object,
    UtilsService: JS5Object,
) {

    // const PACKAGE_EXTERNAL_INGESTS_VIEW_STATE = 'PACKAGE_EXTERNAL_INGESTS_VIEW_STATE';

    //======//
    // Grid //
    //======//

    let gridColumnDefs = [
        {
            field: 'aggregationDate',
            width: 250,
            cellTemplate: 'components/visual/grid/date-time-column-template.html',
        },
        {
            displayName: 'Completed',
            field: 'completed',
            width: 90,
            cellTemplate: 'components/visual/grid/boolean-flag-checkmark-template.html',
        },
        {
            displayName: 'Source Link',
            field: 'sourceFile.uri',
            width: 90,
            cellTemplate: 'components/visual/grid/text-file-download-template.html',
        },
        {
            displayName: 'Source Filename',
            field: 'sourceFile.filename',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
        },
        {
            displayName: 'Transf. Link',
            field: 'transformedFile.uri',
            width: 90,
            cellTemplate: 'components/visual/grid/text-file-download-template.html',
        },
        {
            displayName: 'Transformed Filename',
            field: 'transformedFile.filename',
            cellTemplate: 'components/visual/grid/base-tooltip-template.html',
        },
    ];

    let uriLookup: JS5Object = {};

    this.gridOptions = {
        enableColumnMenus: false,
        enableColumnResizing: false,
        enableFullRowSelection: false,
        enablePaginationControls: false,
        enableRowHeaderSelection: false,
        enableRowSelection: false,
        enableSorting: false,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        multiSelect: false,
        columnDefs: gridColumnDefs,
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };

    this.getAssetURI = (assetVersionId: string) => {
        if (_.size(assetVersionId) <= 0) {
            return undefined;
        }
        return DownloadAssetService.getAssetUri(assetVersionId, 'document', DownloadAssetService.ContentUse.Source);
    };

    this.downloadFile = (taskUri: string) => {
        let file = uriLookup[taskUri];
        UtilsService.downloadFile(file.uri, file.filename);
    };


    //===================//
    // Template Response //
    //===================//

    this.areControlsEnabled = () => {
        return true;
    };

    this.onExternalIdChange = () => {
        if (_.get(this.contentObject, 'externalId.length') == 0)
            this.contentObject.externalId = null;
    };

    this.clearExternalId = () => {
        this.contentObject.externalId = null;
        this.editorForm.$setDirty();
    };

    this.clearExternalDateUpdated = () => {
        this.contentObject.externalDateUpdated = null;
        this.editorForm.$setDirty();
    };


    //=========//
    // Toolbar //
    //=========//

    let isDirty = () => {
        let isDirty = _.get(this, 'editorForm.$dirty');
        return this.contentObject && isDirty;
    };

    this.toolbarButtonDefs = [
        // Save
        {
            label: 'Save',
            enabled: () => isDirty(),
            onClick: () => {
                this.loadingIndicator.show = true;
                ContentEditService.saveEditData().then(() => {
                    this.contentObject = ContentEditService.contentObject;
                    this.loadingIndicator.show = false;
                    this.editorForm.$setPristine();
                });
            }
        },

        // Revert
        {
            label: 'Revert',
            enabled: () => isDirty(),
            onClick: () => {
                ContentEditService.revertEditData();
                this.contentObject = ContentEditService.contentObject;
                this.editorForm.$setPristine();
            }
        },

        // Close
        {
            label: 'Close',
            enabled: () => true,
            onClick: () => ContentEditService.exitEdit(),
        }
    ];


    //=================//
    // Lifecycle Hooks //
    //=================//

    const getEditData = () => {
        return AggregationResourceFactory.getTasks({
            contentId: this.contentObject.id,
            externalSystem: this.contentObject.externalSystem,
            externalId: this.contentObject.externalId,
        }).$promise.then((ingestLogs: JS5Object[]) => {
            this.gridOptions.data = ingestLogs;
            let uriPromises: JS5Object[] = [];
            _.forEach(ingestLogs, (ingestLog: JS5Object) => {
                const sourceFile: JS5Object = {
                    uri: `${EndPointService.aggregationEndPoint}/tasks/${ingestLog.id}/xml?sourceXml=true`,
                    filename: ingestLog.sourceFilename,
                }
                uriLookup[sourceFile.uri] = sourceFile;
                ingestLog.sourceFile = sourceFile;

                const transformedFile: JS5Object = {
                    uri: `${EndPointService.aggregationEndPoint}/tasks/${ingestLog.id}/xml?sourceXml=false`,
                    filename: UtilsService.appendBaseFilename(ingestLog.sourceFilename, '_transformed'),
                }
                uriLookup[transformedFile.uri] = transformedFile;
                ingestLog.transformedFile = transformedFile
            });
            return $q.all(uriPromises);
        });
    };

    this.$onInit = () => {
        this.loadingIndicator.show = true;
        ContentEditService.contentObject.$promise.then(() => {
            this.contentObject = ContentEditService.contentObject;
            return getEditData();
        }).then(() => {
            this.loadingIndicator.show = false;
        });
    };

    this.$postLink = () => {
        $timeout(() => {
            ContentEditService.editorForm = this.editorForm;
        });
    };
}

angular
    .module('prism-ui.content')
    .component('aggregationTab', {
        templateUrl: 'meta/content/editor/components/view/aggregation/aggregation-tab-template.html',
        controller: AggregationTabController,
        bindings: {
            loadingIndicator: '<',
        }
    });
